<template>
<div class="loading-spinner">
    <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
            <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
    </b-modal>
</div>

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'userSetup',
  props: [],
  components: {
  },
  data: () => {
    return {
      token: '',
      courseId: '',
      topicId: '',
      assetId: '',
      page: '',
      redirect: '',
      returnUrl:'',
      openId: '',
      institutionId: '',
      dashboardProgram:''
    }
  },

  mounted () {
  this.$refs.loadingModal.show()
    this.loadUserSetup()
  },

  methods: {
    ...mapActions([
      'loadUserInfo',
      'loadInstitutionDetail',
      'loadInstitutionPackage'
    ]),

    async loadUserSetup () {
      this.token = this.$route.query.token
      this.courseId = this.$route.query.courseId
      this.topicId = this.$route.query.topicId
      this.assetId = this.$route.query.assetId
      this.page = this.$route.query.page
      this.redirect = this.$route.query.redirect
      this.returnUrl = this.$route.query.returnUrl
      this.openId = this.$route.query.openId
      this.institutionId = this.$route.query.institutionId
      this.dashboardProgram = this.$route.query.programCode
      localStorage.setItem('dashboardProgram', this.dashboardProgram)
      localStorage.setItem('institutionId', this.institutionId)
      localStorage.setItem('token', this.token)
      localStorage.setItem('openId', this.openId)
      localStorage.setItem('loginTime', new Date())
      await this.loadUserInfo(this.token).then(userObject1 =>{
          let role = localStorage.getItem('userrole')
          this.loadInstitutionDetail(this.institutionId).then(institution => {
          let institutionId = institution.uuid || this.institutionUuid
          this.loadInstitutionPackage({uuid: institutionId, isAggregated: false}).then(res => {
              if(this.returnUrl && this.returnUrl.length>5){
                  let subPath = this.returnUrl.substring(this.returnUrl.indexOf('#')+1)
                  return this.$router.push(subPath)
//                  window.location.href = this.returnUrl
              }
              if (this.courseId) {
                  if (role === 'Student') {
                      if(this.assetId){
                         return this.$router.push('/course/'+this.courseId+'/learn/LearningContent/'+this.assetId+'/about')
                      }else if(this.topicId){
                         return this.$router.push('/course/'+this.courseId+'/learn/LearningTopic/'+this.topicId+'/about')
                      }else{ // no content link take user to Dashboard
                        return this.$router.push({ name: 'courseDashboard', params: { uuid: this.courseId } })
                      }
                  }else{
                      if(this.assetId){
                         return this.$router.push('/course/'+this.courseId+'/learn/LearningContent/'+this.assetId+'/about/instructor')
                      }else if(this.topicId){
                         return this.$router.push('/course/'+this.courseId+'/learn/LearningTopic/'+this.topicId+'/about/instructor')
                      }else{ // no content link take user to Dashboard
                        return this.$router.push({ name: 'courseDashboardInstructor', params: { uuid: this.courseId } })
                      }
                  }
              } else {
                  return this.$router.push({ name: 'userTrack', params: { role: role.toLowerCase() } })
              }
            })
        })
      })

/*
      await  this.loadInstitutionDetail().then(institution => {
          let institutionId = institution.uuid || this.institutionUuid
          this.loadInstitutionPackage({uuid: institutionId, isAggregated: false}).then(res => {
        })
      })
 */
  }
  },

  computed: {
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/user/components/UserSetup.vue